import FileRequestUpload from './FileRequestUpload';

export const FileRequestUploadConfig = {
    settings: {
      layout          : {
        style : 'layout2',
        config: {
          scroll : 'content',
          navbar : {
            display : false,
            folded  : false,
            position: 'left'
          },
          toolbar: {
            display : false,
            style   : 'fixed',
            position: 'below'
          },
          footer : {
            display : false,
            style   : 'fixed',
            position: 'below'
          },
          mode   : 'fullwidth'
        }
      },
    },
    routes  : [
        {
            path     : '/upload_file_request/:requestId',
            component: FileRequestUpload
        },
        {
            path     : '/upload_file_request',
            component: FileRequestUpload
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/fileRequest/FileRequestUploadConfig.js